import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyD-jYcP7_-TgmPQYi_7sAhads4ESSFrBm8",
  authDomain: "findadz-d152f.firebaseapp.com",
  projectId: "findadz-d152f",
  storageBucket: "findadz-d152f.firebasestorage.app",
  messagingSenderId: "90741863836",
  appId: "1:90741863836:web:4670269c376a5c869c0459",
  measurementId: "G-8DCQ349VMR"
};

let app;
try {
  app = initializeApp(firebaseConfig);
} catch (err) {
  console.log('Firebase init skipped:', err.message);
}

export const requestNotificationPermission = async () => {
  if (!app || !('Notification' in window) || !('serviceWorker' in navigator)) return null;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const { getMessaging, getToken } = await import('firebase/messaging');
    const messaging = getMessaging(app);
    const token = await getToken(messaging, {
      vapidKey: 'BLcOG_1_biSH6mKaL77_pN3yWzPfOO7LPznN_8RHvDqbfp8k1JT2n5swKLfAf3owBXwCW_kLJvWB5Fpelzc5NG8'
    });
    return token;
  } catch (err) {
    console.log('Push permission failed:', err.message);
    return null;
  }
};

export const onMessageListener = () => {
  if (!app || !('Notification' in window)) {
    return Promise.resolve(null);
  }
  
  return new Promise((resolve) => {
    import('firebase/messaging').then(({ getMessaging, onMessage }) => {
      try {
        const messaging = getMessaging(app);
        onMessage(messaging, (payload) => {
          resolve(payload);
        });
      } catch (err) {
        console.log('Message listener failed:', err.message);
        resolve(null);
      }
    }).catch(() => resolve(null));
  });
};
